import React, { Component } from 'react';
import './Menu.css';

class Menu extends Component {
  constructor(props) {
    super(props);
    this.state = { choice: '', joinCreateGame: false, enterCode: false, gamecode: '' };
  }

  onChoice(choice) {
    this.setState({ choice });

    if (choice === 'hvgh' || choice === 'spectate') {
      this.setState({ joinCreateGame: true });
    } else {
      this.props.onChoice(choice, '');
    }
  }

  enterCode() {
    this.props.onChoice(this.state.choice, this.state.gamecode);
  }

  joinGame() {
    this.setState({ joinCreateGame: false, enterCode: true });
  }

  createGame() {
    this.props.onChoice(this.state.choice, '');
  }

  onChange(e) {
    this.setState({ gamecode: e.target.value });
  }

  render() {
    if (this.state.enterCode) {
      return (
        <div className="Menu">
          <h1>Enter game code:</h1>
          <input className="gamecode" onChange={ this.onChange.bind(this) } />
          <div className="choice" onClick={ this.enterCode.bind(this) }>Join game</div>
        </div>
      )
    } else if (this.state.joinCreateGame) {
      return (
        <div className="Menu">
          <div className="choice" onClick={ this.joinGame.bind(this) }>Join game</div>
          <div className="choice" onClick={ this.createGame.bind(this) }>Create game</div>
        </div>
      )
    } else if (!this.state.choice) {
      return (
        <div className="Menu">
          <div className="choice" onClick={ this.onChoice.bind(this, 'hvgh') }>Human vs Global Human</div>
          <div className="choice" onClick={ this.onChoice.bind(this, 'hvlh') }>Human vs Local Human</div>
          <div className="choice" onClick={ this.onChoice.bind(this, 'hva') }>Human vs AI</div>
          <div className="choice" onClick={ this.onChoice.bind(this, 'spectate') }>Spectate</div>
        </div>
      );
    }
  }
}

export default Menu;



// WEBPACK FOOTER //
// ./src/Menu/index.js